// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.social {
  background: #fff;
}
.social_connected {
  color: var(--black-90, #1a1a1a);
  font-size: 4.8vh;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
  text-align: left;
}
.social_emailInput {
  border-top: 0;
  border-right: 0;
  padding: 29px 20px 20px 0px;
  border-bottom: 1px solid transparent;
  border-image: linear-gradient(#ffffff, #f0592a);
  border-image-slice: 1;
  width: 100%;
  color: var(--blue, #253c77);
  font-size: 2.1vh;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
@media (max-width: 576px) {
  .social_emailInput {
    margin-bottom: -2vh;
  }
}
.social_emailInput::placeholder {
  color: var(--blue, #253c77);
}
.social_emailInput:hover, .social_emailInput:focus, .social_emailInput:active {
  border-top: 0;
  border-right: 0;
  border-bottom: 1px solid transparent;
  border-image: linear-gradient(0.1turn, #ffffff, #f0592a);
  border-image-slice: 1;
  border-left: 0;
  border-radius: 0;
}
.social_policy {
  padding: 30px 0px;
}
.social_address {
  padding-top: 2.1vh;
}
.social_row1 {
  padding: 60px 4vw 20px 4vw;
}
.social_divider {
  margin-bottom: 30px;
  border-bottom: 1px solid transparent;
  border-image: linear-gradient(90deg, hsl(0, 0%, 100%), hsl(14, 87%, 55%), hsl(0, 0%, 100%)) 1;
}
.social_headings {
  color: var(--orange-0, #f0592a);
  font-size: 2.8vh;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
.social_insights {
  color: var(--black-70, #4d4d4d);
  font-size: 2.4vh;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  padding: 10px 0px 0px;
}
.social .linkTag {
  text-decoration: none;
}
.social_Arrow {
  margin-left: 5%;
}
.social_cpRow {
  padding: 0 4vw;
}
@media (max-width: 2561px) {
  .social_cpRow {
    padding: 0 4vw 1vw;
  }
}
@media (max-width: 992px) {
  .social_cpRow {
    padding: 0 4vw 2vw;
  }
}
@media (max-width: 576px) {
  .social_cpRow {
    padding: 0 4vw 2vw;
  }
}
.social_rightsReserved {
  color: var(--orange-0, #f0592a);
  font-size: 2.8vh;
  font-style: normal;
  font-weight: 400;
  margin-bottom: 0vw;
}
@media (max-width: 1024px) {
  .social_rightsReserved {
    text-align: center;
    margin-bottom: 2.5vw;
  }
}
@media (max-width: 768px) {
  .social_rightsReserved {
    text-align: center;
  }
}
@media (max-width: 576px) {
  .social_rightsReserved {
    text-align: center;
    margin-bottom: 8vw;
  }
}
.social_termService {
  color: var(--orange-0, #f0592a);
  font-size: 2.8vh;
  font-style: normal;
  font-weight: 400;
  text-decoration-line: underline;
  padding-right: 4vw;
  line-height: 150%;
}
@media (max-width: 768px) {
  .social_termService {
    padding: 0;
    text-align: center;
    font-size: 2.5vh;
  }
}
@media (max-width: 576px) {
  .social_termService {
    padding: 0;
    display: flex;
    justify-content: center;
  }
}
.social_termPrivacyCol {
  display: flex;
  justify-content: end;
  align-content: end;
}
@media (max-width: 1024px) {
  .social_termPrivacyCol {
    justify-content: center;
  }
}
@media (max-width: 789px) {
  .social_termPrivacyCol {
    justify-content: center;
  }
}
@media (max-width: 576px) {
  .social_termPrivacyCol {
    justify-content: center;
  }
}
.social_submitBtn {
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.72) 0%, rgba(240, 89, 42, 0.59) 100%);
  border-radius: 12.9905277402vh;
  box-sizing: border-box;
  text-decoration: none;
  color: #fff;
  display: block;
  height: 8.6603518268vh;
  letter-spacing: 1px;
  text-decoration: none;
  padding: 2px;
  width: 21.650879567vh;
  z-index: 2;
  margin-top: 3.247631935vh;
  margin-bottom: 0vh;
  box-shadow: none;
  border: 2px;
}
@media (max-width: 2561px) {
  .social_submitBtn {
    margin-top: 3vh;
  }
}
@media (max-width: 1025px) {
  .social_submitBtn {
    margin-top: 3vh;
  }
}
@media (max-width: 992px) {
  .social_submitBtn {
    width: 18vh;
    height: 8vh;
    margin-top: 1vh;
  }
}
@media (max-width: 768px) {
  .social_submitBtn {
    width: 19vh;
    height: 7vh;
    margin: 0vh auto 2vh auto;
  }
}
@media (max-width: 576px) {
  .social_submitBtn {
    width: 21vh;
    height: 8vh;
    margin: 0vh auto 2vh auto;
  }
}
.social_submitBtn:hover, .social_submitBtn:focus, .social_submitBtn:active {
  background: linear-gradient(165deg, rgba(255, 255, 255, 0.72) 0%, rgb(240, 89, 42) 50%, rgba(240, 89, 42, 0.59) 100%) !important;
}
.social_submitBtn:hover span {
  background: #f0592a;
  color: white;
}
.social_submitBtn span {
  color: white !important;
  align-items: center;
  background: #201b36;
  border-radius: 5.4127198917vh;
  display: flex;
  justify-content: center;
  height: 100%;
  transition: background 0.5s ease;
  width: 100%;
  font-size: 2.4357239513vh;
  font-weight: 500;
}
@media (max-width: 992px) {
  .social_submitBtn span {
    font-size: 1.8vh;
  }
}
@media (max-width: 768px) {
  .social_submitBtn span {
    font-size: 2vh;
  }
}

.socialAlign {
  text-align: start;
  text-decoration: underline;
}

.socialAlignCenter {
  text-align: center;
}

@media (max-width: 992px) {
  .social {
    padding: 0px 20px;
  }
  .socialAlign {
    text-align: center;
  }
  .social_connected {
    margin-bottom: 25px;
  }
  .social_address {
    margin-bottom: 25px;
  }
  .social_commonbtn {
    margin-top: 0px;
  }
}
@media (max-width: 1025px) {
  .social_connected {
    margin-left: 0px;
  }
}
@media screen and (min-width: 1200px) {
  .footer_icon {
    width: 3vw !important;
    height: 10vh;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Layouts/Social/social.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;AACE;EACE,+BAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AACJ;AAEE;EACE,aAAA;EACA,eAAA;EACA,2BAAA;EACA,oCAAA;EACA,+CAAA;EACA,qBAAA;EACA,WAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAAJ;AAEI;EAdF;IAeI,mBAAA;EACJ;AACF;AAEE;EACE,2BAAA;AAAJ;AAGE;EAGE,aAAA;EACA,eAAA;EACA,oCAAA;EACA,wDAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;AAHJ;AAME;EACE,iBAAA;AAJJ;AAOE;EACE,kBAAA;AALJ;AAQE;EACE,0BAAA;AANJ;AASE;EACE,mBAAA;EACA,oCAAA;EACA,6FAAA;AAPJ;AAgBE;EACE,+BAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAdJ;AAkBE;EACE,+BAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AAhBJ;AAmBE;EACE,qBAAA;AAjBJ;AAoBE;EACE,eAAA;AAlBJ;AAqBE;EACE,cAAA;AAnBJ;AAoBI;EAFF;IAGI,kBAAA;EAjBJ;AACF;AAkBI;EALF;IAMI,kBAAA;EAfJ;AACF;AAgBI;EARF;IASI,kBAAA;EAbJ;AACF;AAgBE;EACE,+BAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAdJ;AAgBI;EAPF;IAQI,kBAAA;IACA,oBAAA;EAbJ;AACF;AAcI;EAXF;IAYI,kBAAA;EAXJ;AACF;AAYI;EAdF;IAeI,kBAAA;IACA,kBAAA;EATJ;AACF;AAWE;EACE,+BAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+BAAA;EACA,kBAAA;EACA,iBAAA;AATJ;AAUI;EARF;IASI,UAAA;IACA,kBAAA;IACA,gBAAA;EAPJ;AACF;AAQI;EAbF;IAcI,UAAA;IACA,aAAA;IACA,uBAAA;EALJ;AACF;AAQE;EACE,aAAA;EACA,oBAAA;EACA,kBAAA;AANJ;AAOI;EAJF;IAKI,uBAAA;EAJJ;AACF;AAKI;EAPF;IAQI,uBAAA;EAFJ;AACF;AAGI;EAVF;IAWI,uBAAA;EAAJ;AACF;AAEE;EACE,8FAAA;EAKA,8BAAA;EACA,sBAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;EACA,qBAAA;EACA,YAAA;EACA,qBAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;AAJJ;AAKI;EArBF;IAsBI,eAAA;EAFJ;AACF;AAGI;EAxBF;IAyBI,eAAA;EAAJ;AACF;AACI;EA3BF;IA4BI,WAAA;IACA,WAAA;IACA,eAAA;EAEJ;AACF;AADI;EAhCF;IAiCI,WAAA;IACA,WAAA;IACA,yBAAA;EAIJ;AACF;AAHI;EArCF;IAsCI,WAAA;IACA,WAAA;IACA,yBAAA;EAMJ;AACF;AAHE;EAGE,gIAAA;AAGJ;AAKE;EACE,mBAAA;EACA,YAAA;AAHJ;AAKE;EACE,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,gCAAA;EACA,WAAA;EACA,yBAAA;EACA,gBAAA;AAHJ;AAII;EAZF;IAaI,gBAAA;EADJ;AACF;AAEI;EAfF;IAgBI,cAAA;EACJ;AACF;;AAGA;EACE,iBAAA;EACA,0BAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE;IACE,iBAAA;EAAF;EAGA;IACE,kBAAA;EADF;EAIA;IACE,mBAAA;EAFF;EAKA;IACE,mBAAA;EAHF;EAKA;IACE,eAAA;EAHF;AACF;AAMA;EACE;IACE,gBAAA;EAJF;AACF;AAOE;EADF;IAEI,qBAAA;IACA,YAAA;EAJF;AACF","sourcesContent":[".social {\n  background: #fff;\n\n  &_connected {\n    color: var(--black-90, #1a1a1a);\n    font-size: 4.8vh;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 130%;\n    text-align: left;\n  }\n\n  &_emailInput {\n    border-top: 0;\n    border-right: 0;\n    padding: 29px 20px 20px 0px;\n    border-bottom: 1px solid transparent;\n    border-image: linear-gradient(#ffffff, #f0592a);\n    border-image-slice: 1;\n    width: 100%;\n    color: var(--blue, #253c77);\n    font-size: 2.1vh;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n\n    @media (max-width: 576px) {\n      margin-bottom: -2vh;\n    }\n  }\n\n  &_emailInput::placeholder {\n    color: var(--blue, #253c77);\n  }\n\n  &_emailInput:hover,\n  &_emailInput:focus,\n  &_emailInput:active {\n    border-top: 0;\n    border-right: 0;\n    border-bottom: 1px solid transparent;\n    border-image: linear-gradient(0.1turn, #ffffff, #f0592a);\n    border-image-slice: 1;\n    border-left: 0;\n    border-radius: 0;\n  }\n\n  &_policy {\n    padding: 30px 0px;\n  }\n\n  &_address {\n    padding-top: 2.1vh;\n  }\n\n  &_row1 {\n    padding: 60px 4vw 20px 4vw;\n  }\n\n  &_divider {\n    margin-bottom: 30px;\n    border-bottom: 1px solid transparent;\n    border-image: linear-gradient(\n        90deg,\n        hsla(0, 0%, 100%, 1),\n        hsla(14, 87%, 55%, 1),\n        hsla(0, 0%, 100%, 1)\n      )\n      1;\n  }\n\n  &_headings {\n    color: var(--orange-0, #f0592a);\n    font-size: 2.8vh;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%;\n    // text-transform: uppercase;\n  }\n\n  &_insights {\n    color: var(--black-70, #4d4d4d);\n    font-size: 2.4vh;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%;\n    padding: 10px 0px 0px;\n  }\n\n  .linkTag {\n    text-decoration: none;\n  }\n\n  &_Arrow {\n    margin-left: 5%;\n  }\n\n  &_cpRow {\n    padding: 0 4vw;\n    @media (max-width: 2561px) {\n      padding: 0 4vw 1vw;\n    }\n    @media (max-width: 992px) {\n      padding: 0 4vw 2vw;\n    }\n    @media (max-width: 576px) {\n      padding: 0 4vw 2vw;\n    }\n  }\n\n  &_rightsReserved {\n    color: var(--orange-0, #f0592a);\n    font-size: 2.8vh;\n    font-style: normal;\n    font-weight: 400;\n    margin-bottom: 0vw;\n    // text-transform: uppercase;\n    @media (max-width: 1024px) {\n      text-align: center;\n      margin-bottom: 2.5vw;\n    }\n    @media (max-width: 768px) {\n      text-align: center;\n    }\n    @media (max-width: 576px) {\n      text-align: center;\n      margin-bottom: 8vw;\n    }\n  }\n  &_termService {\n    color: var(--orange-0, #f0592a);\n    font-size: 2.8vh;\n    font-style: normal;\n    font-weight: 400;\n    text-decoration-line: underline;\n    padding-right: 4vw;\n    line-height: 150%;\n    @media (max-width: 768px) {\n      padding: 0;\n      text-align: center;\n      font-size: 2.5vh;\n    }\n    @media (max-width: 576px) {\n      padding: 0;\n      display: flex;\n      justify-content: center;\n    }\n  }\n\n  &_termPrivacyCol {\n    display: flex;\n    justify-content: end;\n    align-content: end;\n    @media (max-width: 1024px) {\n      justify-content: center;\n    }\n    @media (max-width: 789px) {\n      justify-content: center;\n    }\n    @media (max-width: 576px) {\n      justify-content: center;\n    }\n  }\n  &_submitBtn {\n    background: linear-gradient(\n      90deg,\n      rgba(255, 255, 255, 0.72) 0%,\n      rgba(240, 89, 42, 0.59) 100%\n    );\n    border-radius: 12.990527740189446vh;\n    box-sizing: border-box;\n    text-decoration: none;\n    color: #fff;\n    display: block;\n    height: 8.660351826792963vh;\n    letter-spacing: 1px;\n    text-decoration: none;\n    padding: 2px;\n    width: 21.650879566982407vh;\n    z-index: 2;\n    margin-top: 3.2476319350473615vh;\n    margin-bottom: 0vh;\n    box-shadow: none;\n    border: 2px;\n    @media (max-width: 2561px) {\n      margin-top: 3vh;\n    }\n    @media (max-width: 1025px) {\n      margin-top: 3vh;\n    }\n    @media (max-width: 992px) {\n      width: 18vh;\n      height: 8vh;\n      margin-top: 1vh;\n    }\n    @media (max-width: 768px) {\n      width: 19vh;\n      height: 7vh;\n      margin: 0vh auto 2vh auto;\n    }\n    @media (max-width: 576px) {\n      width: 21vh;\n      height: 8vh;\n      margin: 0vh auto 2vh auto;\n    }\n  }\n\n  &_submitBtn:hover,\n  &_submitBtn:focus,\n  &_submitBtn:active {\n    background: linear-gradient(\n      165deg,\n      rgba(255, 255, 255, 0.72) 0%,\n      rgba(240, 89, 42, 1) 50%,\n      rgba(240, 89, 42, 0.59) 100%\n    ) !important;\n  }\n\n  &_submitBtn:hover span {\n    background: #f0592a;\n    color: white;\n  }\n  &_submitBtn span {\n    color: white !important;\n    align-items: center;\n    background: #201b36;\n    border-radius: 5.412719891745602vh;\n    display: flex;\n    justify-content: center;\n    height: 100%;\n    transition: background 0.5s ease;\n    width: 100%;\n    font-size: 2.435723951285521vh;\n    font-weight: 500;\n    @media (max-width: 992px) {\n      font-size: 1.8vh;\n    }\n    @media (max-width: 768px) {\n      font-size: 2vh;\n    }\n  }\n}\n\n.socialAlign {\n  text-align: start;\n  text-decoration: underline;\n}\n\n.socialAlignCenter {\n  text-align: center;\n}\n\n@media (max-width: 992px) {\n  .social {\n    padding: 0px 20px;\n  }\n\n  .socialAlign {\n    text-align: center;\n  }\n\n  .social_connected {\n    margin-bottom: 25px;\n  }\n\n  .social_address {\n    margin-bottom: 25px;\n  }\n  .social_commonbtn {\n    margin-top: 0px;\n  }\n}\n\n@media (max-width: 1025px) {\n  .social_connected {\n    margin-left: 0px;\n  }\n}\n.footer_icon {\n  @media screen and (min-width: 1200px) {\n    width: 3vw !important;\n    height: 10vh;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
